
{
  "title": "选择您的方案",
  "subtitle": "为您的业务需求选择完美的方案",
  "buttons": {
    "signUp": "注册",
    "currentPlan": "当前方案",
    "purchase": "购买",
    "notAvailable": "不可用"
  },
  "comparison": {
    "headers": {
      "features": "比较方案"
    },
    "badges": {
      "whatsapp": "WhatsApp",
      "premium": "成长"
    },
    "features": {
      "listings": "服务列表",
      "categories": "类别",
      "areas": "服务区域",
      "profile": "商户档案",
      "verifiedBadge": "验证徽章",
      "analytics": "列表分析",
      "priority": "优先排序"
    },
    "values": {
      "allServiceAreas": "所有服务区域"
    },
    "included": "包含",
    "notIncluded": "不包含"
  },
  "pricingTable": {
    "free": {
      "title": "免费",
      "price": "HK$0",
      "period": "永久",
      "description": "适合初学者",
      "features": {
        "maxListings": "1个服务列表",
        "singleCategory": "每个列表单一类别",
        "maxAreas": "最多3个服务区域",
        "basicProfile": "基本个人资料功能"
      }
    },
    "whatsapp": {
      "title": "WhatsApp 验证",
      "price": "HK$100",
      "period": "一次性",
      "description": "获得WhatsApp验证徽章",
      "features": {
        "maxListings": "1个服务列表",
        "singleCategory": "每个列表单一类别",
        "maxAreas": "最多3个服务区域",
        "basicProfile": "基本个人资料功能",
        "verifiedBadge": "WhatsApp验证徽章",
        "listingAnalytics": "列表分析"
      }
    },
    "premium": {
      "title": "高级版",
      "price": "HK$500",
      "period": "月",
      "description": "成长所需的一切",
      "features": {
        "unlimitedListings": "无限服务列表",
        "multipleCategories": "每个列表多个类别",
        "enhancedProfile": "增强个人资料功能",
        "verifiedBadge": "WhatsApp验证徽章",
        "priorityPlacement": "搜索优先排序",
        "listingAnalytics": "列表分析"
      }
    }
  },
  "faq": {
    "title": "常见问题",
    "howToStart": "如何开始？",
    "howToStartAnswer": "只需注册一个账户，您就可以立即开始浏览服务。",
    "howToStartAnswerLoggedIn": "您已经注册了！您可以开始创建列表或升级到高级方案。",
    "howToUpgrade": "如何升级我的方案？",
    "howToUpgradeAnswer": "您可以随时从账户设置升级您的方案。",
    "howToUpgradeAnswerGuest": "请先注册账户，然后您可以选择您偏好的方案。",
    "canCancel": "可以随时取消吗？",
    "canCancelAnswer": "是的，您可以随时取消订阅。您当前的权益将持续到计费周期结束。",
    "paymentMethods": "您接受哪些付款方式？",
    "paymentMethodsAnswer": "Stripe Checkout 会根据您的地区与 Stripe 可用性，在结账时直接显示支持的付款方式。",
    "tierDifference": "层级之间有什么区别？",
    "tierDifferenceAnswer": "每个层级提供不同的功能和限制。高级用户可获得无限列表和高级功能。"
  }
}
